import React, { useState} from "react";
// import { connect } from "react-redux";
// import { Link } from "react-router-dom";
import constants from "../../../constants";
import TableDropdownAndPagination from "../../../services/TableDropdownAndPagination";
import { checkIfFileIsaDocument } from "../../../services/FileOperationGlobalFunctions";
import GlobalViewFileModal from "../../../services/GlobalViewFileModal";
import { redirectUrl } from "../../../services/GlobalUrls";
import { TableLoader } from "../SkeletonLoader/TableLoader";
import ExportButtons from "../SkeletonLoader/ExportButtons";
import TableNewPaginanation from "../../../services/TableNewPaginanation";
const PoliciesAndProceduresDesktop = ({ policiesList, ...props }) => {
  // const [setRecordLen] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  // const [dataLen, setDataLen] = useState(0);
  // const [filter, setFilter] = useState("");
  const [modalOption, setModalOption] = useState(false);
  const [modalHeight, setModalHeight] = useState("500px");
  const [fileUrl, setFileUrl] = useState("");
  const [fileName, setFileName] = useState("");
// Filter applied jobs based on the search text

  //   Filter - Start
  const [inputValue, setInputValue] = useState("");
  const matchesSearchText = (policiesDetails) => {
    const searchText = inputValue.toLowerCase();
    return (
      policiesDetails.policy_created_date.toLowerCase().includes(searchText) ||
      policiesDetails.policies_and_procedures_policy_name
        .toLowerCase()
        .includes(searchText)
    );
  };
const filterRows = policiesList ? policiesList.filter(matchesSearchText) : [];
const totalItems = filterRows.length;

const startIndex =
  recordsPerPage === "all"
    ? 0
    : (currentPage - 1) * recordsPerPage;

const endIndex =
  recordsPerPage === "all"
    ? totalItems
    : startIndex + recordsPerPage;
const onPageChange = (page, pageSize = recordsPerPage) => {
  setCurrentPage(page);
  setRecordsPerPage(pageSize);
};


  // useEffect(() => {
  //   const lenOfData = policiesList?.length;
  //   // console.log("lenOfData", lenOfData);
  //   setDataLen(lenOfData);
  //   totalPages = Math.ceil(lenOfData / recordsPerPage);
  //   startIndex = (currentPage - 1) * recordsPerPage;
  //   endIndex = Math.min(startIndex + recordsPerPage, lenOfData);
  // }, [policiesList]);

  // const handleLeft = () => {
  //   setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  // };

  // const handleRight = () => {
  //   setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  // };

  // const visiblePages = 4;

  // const renderPageNumbers = () => {
  //   const pageNumbers = [];
  //   let startPage = currentPage - Math.floor(visiblePages / 2);
  //   let endPage = currentPage + Math.floor(visiblePages / 2);

  //   if (startPage < 1) {
  //     startPage = 1;
  //     endPage = Math.min(totalPages, visiblePages);
  //   }

  //   if (endPage > totalPages) {
  //     endPage = totalPages;
  //     startPage = Math.max(1, totalPages - visiblePages + 1);
  //   }

  //   for (let i = startPage; i <= endPage; i++) {
  //     pageNumbers.push(
  //       <li
  //         key={i}
  //         className={i === currentPage ? "active" : ""}
  //         onClick={() => {
  //           setCurrentPage(i);
  //           setFilter("");
  //         }}
  //       >
  //         <Link to="#">{i}</Link>
  //       </li>
  //     );
  //   }

  //   return pageNumbers;
  // };

  // const handleDropDown = (value) => {
  //   setRecordLen(value);
  //   setRecordsPerPage(value);
  //   setCurrentPage(1);
  // };
  const viewFileModal = (url, fileName) => {
    if (checkIfFileIsaDocument(url)) {
      setModalHeight("500px");
      setFileUrl(url);
      setFileName(fileName);
    } else {
      redirectUrl(url);
    }
  };

  const callModal = () => {
    document.getElementById("loader").style.display = "block";
    setModalOption(true);
  };
  const loaderEnd = () => {
    document.getElementById("loader").style.display = "none";
    setModalHeight("auto");
  };

  const closeFileModal = () => {
    setModalOption(false);
    setFileUrl("");
  };



  // Filter applied jobs based on the search text
  // const filterRows = policiesList ? policiesList.filter(matchesSearchText) : [];
  //   Filter - End


const preparePoliciesExportData = (data) => {
  if (!data || data.length === 0) return [];

  return data.map((policy, index) => ({
    "Sr.No.": index + 1,
    "Date & Time": policy.policy_created_date || "-",
    "Policy Name":
      policy.policies_and_procedures_policy_name || "-",
  }));
};


const exportData = React.useMemo(() => {
  return preparePoliciesExportData(filterRows);
}, [filterRows]);

  return (
    <React.Fragment>
      <div className="m-b30 wrapper">
        {/* Search Start */}
       {/* Search Start */}
<div className="container">
  <div className="row align-items-center mb-3">

    {/* LEFT – Export Buttons */}
    <div className="col-sm-6 d-flex align-items-center">
      {/* <ExportButtons
        data={exportData}
        fileName="Policies_And_Procedures"
        buttons={true}
      /> */}
    </div>

    {/* RIGHT – Search */}
    <div className="col-sm-6 d-flex justify-content-end">
      <input
        type="text"
        name="search"
        className="form-control"
        placeholder="Search here"
        style={{ height: "40px", width: "200px" }}
        onInput={(event) => setInputValue(event.target.value)}
      />
    </div>

  </div>
</div>
{/* Search End */}

        {/* Search End */}
       <div className="courses-section">
        { !policiesList || policiesList.length === 0 ? (
    // 🔹 Show skeleton loader while data is loading
    <TableLoader rows={10} columns={3} showHeader={false} />
  ) : (

         <table className="courses-table">
            <thead className="text-white">
            <tr>
              {/*<th  className="col-1 text-center" scope="col">Sr. No</th>*/}
              <th className="col-3 text-center" scope="col">
                Date & Time
              </th>
              {/*<th  className="col-2 text-center" scope="col">Email</th>*/}
              <th className="col-3 text-center" scope="col">
                Policy Name
              </th>
              <th className="col-3 text-center" scope="col">
                Policy Document
              </th>
              {/*<th  className="col-1 text-center" scope="col">Action</th>*/}
            </tr>
          </thead>
          <tbody id="myTable">
            {filterRows &&
              filterRows.length > 0 &&
              filterRows
                .slice(startIndex, endIndex)
                .map((policiesDetails, i) => (
                  <tr key={i}>
                    {/*<td className="col-1 text-center" scope="row">
                    {i + 1}
              </td>*/}
<td
  className="col-4 text-center"
  style={{ whiteSpace: "pre-line", lineHeight: "1.4" }}
>
  {policiesDetails.policy_created_date
    ? policiesDetails.policy_created_date.replace(" ", "\n")
    : "-"}
</td>

                    <td className="col-3 text-center">
                      {policiesDetails.policies_and_procedures_policy_name}
                    </td>

                    <td className="col-3 text-center" >
                      {policiesDetails.policy_document ? (
                        <button
                          rel="noopener noreferrer"
                          download
                          onClick={() =>
                            viewFileModal(
                              constants.IMAGE_URL +
                                policiesDetails.policy_document,
                              policiesDetails.policies_and_procedures_policy_name
                            )
                          }
                          className={
                            "btn btn-" +
                            (policiesDetails.policy_document.endsWith(".png") ||
                            policiesDetails.policy_document.endsWith(".jpg") ||
                            policiesDetails.policy_document.endsWith(".jpeg") ||
                            policiesDetails.policy_document.endsWith(".pdf")
                              ? "dark"
                              : "primary") +
                            " btn-sm text-white"
                          }
                        >
                          <i
                            className={
                              "fa fa-" +
                              (policiesDetails.policy_document.endsWith(
                                ".png"
                              ) ||
                              policiesDetails.policy_document.endsWith(
                                ".jpg"
                              ) ||
                              policiesDetails.policy_document.endsWith(
                                ".jpeg"
                              ) ||
                              policiesDetails.policy_document.endsWith(".pdf")
                                ? "eye" //"eye"
                                : "download")
                            }
                          ></i>
                        </button>
                      ) : (
                        " - "
                      )}
                    </td>
                  </tr>
                ))}
            {filterRows.length === 0 && (
              <tr>
                <td colSpan="100" className="text-center">No Policies Found</td>
              </tr>
            )}
          </tbody>
        </table>
         )}
        </div>
       {totalItems > 0 && (
  <TableNewPaginanation
    totalItems={totalItems}
    pageSize={recordsPerPage}
    currentPage={currentPage}
    onPageChange={onPageChange}
    isDropdown={true}
    isPaggination={true}
  />
)}
      </div>
      <GlobalViewFileModal
        modalOption={modalOption}
        closeFileModal={closeFileModal}
        fileUrl={fileUrl}
        // fileName={fileName}
        loaderEnd={loaderEnd}
        modalHeight={modalHeight}
        callModal={callModal}
        title={"Policy Document - " + fileName}
      />
    </React.Fragment>
  );
};

export default PoliciesAndProceduresDesktop;